import React from 'react';
import { Button, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import CircleWithPlusWhite from '../../assets/icons/CircleWithPlusWhite.svg';

const AddToBundleButton = ({ onClick, sx, disabled }) => {
    const defaultSx = {
        width: 200,
        height: 48,
        backgroundColor: '#FF669B',
        color: '#FFFFFF',
        borderRadius: '36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '0 16px 0 56px',
        transition: 'none',
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '16px',
        letterSpacing: 0,
        '&:hover': {
            backgroundColor: '#FF669B',
            color: '#FFFFFF',
        },
        ...(disabled && {
            backgroundColor: '#F0EFF1',
            color: '#979797',
            cursor: 'not-allowed',
            pointerEvents: 'none',
        }),
        ...sx,
    };

    return (
        <Button onClick={onClick} sx={defaultSx} disabled={disabled}>
            <img
                src={CircleWithPlusWhite}
                alt="Add icon"
                style={{
                    position: 'absolute',
                    left: 8,
                    width: 36,
                    height: 36,
                }}
            />
            <Typography
                variant="inherit"
                sx={{
                    fontFamily: 'Inter',
                    fontWeight: 500,
                    fontSize: '18px',
                    lineHeight: '18px',
                    letterSpacing: 0,
                }}
            >
                Add to bundle
            </Typography>
        </Button>
    );
};

AddToBundleButton.propTypes = {
    onClick: PropTypes.func,
    sx: PropTypes.object,
    disabled: PropTypes.bool,
};

AddToBundleButton.defaultProps = {
    onClick: () => {},
    sx: {},
    disabled: false,
};

export default AddToBundleButton;
